export const COMPANY = {
  name: "ZAKE Mühendislik",
  fullName:
    "ZAKE Mühendislik Çevre Tek. ve Tek. Emn. Sis. San. ve Tic. Ltd. Şti.",
  address: "Uzayçağı Cad. No:62/4 OSTİM",
  district: "Yenimahalle / Ankara",
  country: "Türkiye",
  phone: "+90 850 466 92 53",
  phoneRaw: "+908504669253",
  phoneLocal: "+90 312 386 05 77",
  phoneLocalRaw: "+903123860577",
  fax: "+90 312 386 05 22",
  email: "zake@zake.com.tr",
  kep: "zake@hs01.kep.tr",
  website: "zake.com.tr",
  taxOffice: "Ostim V.D.",
  registrationNo: "249479",
  mersis: "0996034463500010",
  mapsQuery: "ZAKE+Mühendislik+Uzayçağı+Cad+62+OSTİM+Ankara",
  // OSTİM Ankara coordinates
  coordinates: { lat: 39.9817, lng: 32.7649 },
};
